module.exports = __webpack_public_path__ + "img/home-solid.e72fecb6.svg";